module.exports = __webpack_public_path__ + "38bee85ffa178a4781fa45e29c333b93.MP3";